import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from 'react-apollo';
import { FaTrash } from 'react-icons/fa';
import { DELETE_CATEGORY } from '../queries';
import { showConfirmation } from '../ConfirmationDialogService';
import { toast } from 'react-toastify';

const getMessage = name => (
  <>
    <span>
      Permanently delete category{' '}
      <strong style={{ color: 'red' }}>{name}</strong>?
      <br />
      <br />
      All specialization mappings linked to this category will lose their link.
      <br />
      <br />
      <strong>THIS PROCESS IS IRREVERSIBLE!</strong>
    </span>
  </>
);

const DeleteCategory = ({ category, onSuccess }) => {
  const [deleteCategory, { loading }] = useMutation(DELETE_CATEGORY, {
    refetchQueries: ['GET_SPECIALIZATION_MAPPING'],
    onCompleted: () => {
      toast.success('Category deleted successfully');
      if (onSuccess) onSuccess();
    },
    onError: err => {
      toast.error(err.message || 'Failed to delete category');
    }
  });

  const confirm = () => {
    showConfirmation('Delete Category?', getMessage(category.name), () =>
      deleteCategory({
        variables: { id: category.id }
      })
    );
  };

  return (
    <span
      className="delete"
      onClick={() => !loading && confirm()}
      style={{ cursor: loading ? 'not-allowed' : 'pointer' }}
    >
      <FaTrash />
      Delete
    </span>
  );
};

DeleteCategory.propTypes = {
  category: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  onSuccess: PropTypes.func
};

export default DeleteCategory;
